import { FileTextOutlined } from '@ant-design/icons';
import { Radio2Icon, SunFogyIcon, TeamIcon } from '@marine/icons';
import { Tag, TagProps } from 'antd';
import { FC, useCallback, useMemo } from 'react';
import styles from './LogTypeColumn.module.scss';
import { LogTypeColumnProps } from './LogTypeColumn.props';

interface ITagProps {
  value: string;
  className?: string;
  color: TagProps['color'];
  icon: TagProps['icon'];
}

const LogTypeColumn: FC<LogTypeColumnProps> = ({ value }) => {
  const tagProps = useMemo<ITagProps>(() => {
    switch (value) {
      case 'general':
        return {
          color: 'gray',
          icon: <FileTextOutlined size={10} />,
          value: value.toString(),
          className: styles.logTypeGeneral,
        };
      case 'weather':
        return {
          color: 'cyan',
          icon: <SunFogyIcon size={10} />,
          value: value.toString(),
        };
      case 'radio':
        return {
          color: 'gold',
          icon: <Radio2Icon size={10} />,
          value: value.toString(),
        };
      case 'social':
        return {
          color: 'blue',
          icon: <TeamIcon size={10} />,
          value: value.toString(),
        };
      case 'usage':
        return {
          color: 'magenta',
          icon: <TeamIcon size={10} />,
          value: value.toString(),
        };

      default:
        return {
          color: 'green',
          icon: <FileTextOutlined />,
          value: '(Unknown)',
        };
    }
  }, [value]);

  const renderTypeColumn = useCallback((logType: string) => {
    if (logType === 'usage') {
      return 'Operations';
    }

    return logType;
  }, []);

  return (
    <div className={styles.logTypeColumnWrapper}>
      <Tag
        color={tagProps.color}
        icon={tagProps.icon}
        className={`${styles.logTypeItem} ${tagProps.className ? tagProps.className : ''}`}
      >
        {renderTypeColumn(tagProps.value)}
      </Tag>
    </div>
  );
};

export { LogTypeColumn };
